import { isMobile } from 'react-device-detect';
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar';
import { PageTitle } from '../../components/title/PageTitle';

export default function Benefit() {
  return (
    <>
      <div className="main_wrap">
        <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap full'}>
          <MyShoppingSideBar />
          <div className="myshopping_wrap">
            <PageTitle>혜택 소개</PageTitle>
          </div>
        </div>
      </div>
    </>
  );
}
